import React from 'react';
import IconWrapper from '../IconWrapper';
const CheckboxWithBackgroundIcon = (props) => (React.createElement(IconWrapper, Object.assign({ viewBox: "1 1 24 24" }, props),
    React.createElement("circle", { cx: "13", cy: "13", r: "11", fill: "#8DD5B9", stroke: "#fff", strokeWidth: "2" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 9.684 18.264 9l-7.421 7.635L7.653 14 7 14.763l3.897 3.219.02.018.001-.001.002.001.018-.021L19 9.684Z", fill: "#222" })));
export default CheckboxWithBackgroundIcon;
//# sourceMappingURL=CheckboxWithBackgroundIcon.js.map